var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82586 1.175C6.10086 0.45 5.10586 0 4.00086 0C1.79086 0 0.00585938 1.79 0.00585938 4C0.00585938 6.21 1.79086 8 4.00086 8C5.86586 8 7.42086 6.725 7.86586 5H6.82586C6.41586 6.165 5.30586 7 4.00086 7C2.34586 7 1.00086 5.655 1.00086 4C1.00086 2.345 2.34586 1 4.00086 1C4.83086 1 5.57086 1.345 6.11086 1.89L4.50086 3.5H8.00086V0L6.82586 1.175Z",
    fill: "#687484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.252a8cd6838f8d13d5356d32ddda7c42.svg";
export { ForwardRef as ReactComponent };